import styled from "styled-components";

export default function Home() {
  return (
    <Content>
      <Block>
        <img src="/img/logo-amai.png" alt="AMAI" />
        <Texto>
          Fundada em 1977, a AMAI – Associação dos Moradores e Amigos de Ipanema – é uma das representações mais antigas da Zona Sul carioca.
        </Texto>
        <CliqueAqui>Clique aqui</CliqueAqui>
      </Block>

      <Block>
        <img src="/img/logo-viva.png" alt="Viva Ipanema" />
        <Texto>
          Mais que um sentimento, o Projeto Viva Ipanema busca valorizar a qualidade de vida e a positividade do bairro e dos frequentadores.
        </Texto>
        <CliqueAqui>Clique aqui</CliqueAqui>
      </Block>

      <Block>
        <img src="/img/logo-rotary.png" alt="Rotary" />
        <Texto>
          O Rotary é uma organização de líderes empresariais e profissionais, unidos em todo o mundo para prestar serviços humanitários, promover elevados padrões éticos em todas as profissões e contribuir para a construção da paz e da boa vontade entre os povos.
        </Texto>
        <CliqueAqui>Clique aqui</CliqueAqui>
      </Block>

      <Block>
        <img src="/img/logo-camara.png" alt="Câmara" />
        <Texto>
          A Câmara de Dirigentes Lojistas do Rio de Janeiro é a operadora exclusiva, na cidade do Rio de Janeiro, do quase centenário SPC, um dos maiores e mais respeitados sistemas de informações de crédito do país.
        </Texto>
        <CliqueAqui onClick={() => window.open("https://www.spcrio.com", "_blank")}>
          Clique aqui
        </CliqueAqui>
      </Block>

      <Block>
        <img src="/img/logo-pet.png" alt="Pet" />
        <Texto>
          Os Cachorreiros da Paz e o Dogs General Osório têm como objetivo ajudar cães e gatos em situação de rua, além de compartilhar o dia a dia de nossos amiguinhos.
        </Texto>
        <CliqueAqui>Clique aqui</CliqueAqui>
      </Block>
    </Content>
  );
}

const Content = styled.div`
  width: 100%;
  max-width: 1300px;
  margin: 0 auto;
  padding: 20px;

  box-sizing: border-box;

  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 1fr);
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    padding: 10px;
  }
`;

const Block = styled.div`
  width: 100%;
  min-height: 400px;

  background-color: #ffffff;
  border: 2px solid #55cdff;
  border-radius: 20px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  img {
    max-width: 100%;
    height: auto;
    border-radius: 20px 20px 0 0;
  }

  @media (max-width: 600px) {
    min-height: auto;
  }
`;

const Texto = styled.p`
  font-family: "Poppins", sans-serif;
  padding: 20px;
  font-size: 16px;
  text-align: center;
  color: #212529;

  @media (max-width: 600px) {
    font-size: 15px;
    padding: 15px;
  }
`;

const CliqueAqui = styled.button`
  width: 100%;
  height: 60px;

  border: 0;
  border-radius: 0 0 20px 20px;

  font-size: 20px;
  background-color: #0d6efd;
  color: #ffffff;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  @media (max-width: 600px) {
    font-size: 18px;
    height: 55px;
  }
`;
